module.exports = __webpack_public_path__ + "img/FV.f07ca338.png";